import { render, staticRenderFns } from "./ExecucaoAtiva.vue?vue&type=template&id=dde254d4&"
import script from "./ExecucaoAtiva.vue?vue&type=script&lang=js&"
export * from "./ExecucaoAtiva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports